'use client';

import { useEffect, useState } from 'react';

import { CoordinatesInterface } from 'types';

type PermissionState = 'granted' | 'denied' | 'prompt';

export const useGeolocation = () => {
  const [geoLocation, setGeoLocation] = useState<CoordinatesInterface | null>(
    null
  );
  const [permissionStatus, setPermissionStatus] =
    useState<PermissionState | null>(null);

  const handlePosition = (position: GeolocationPosition) => {
    const location: CoordinatesInterface = {
      longitude: position.coords.longitude,
      latitude: position.coords.latitude
    };
    setGeoLocation(location);
  };

  useEffect(() => {
    if ('permissions' in navigator) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then((result: PermissionStatus) => setPermissionStatus(result.state));
    }
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(handlePosition, (error) => {
        console.error(`Error fetching geolocation: ${error.message}`);
      });
    }
  }, []);

  return { geoLocation, permissionStatus };
};
